import { useEffect } from 'react'
import { notifications } from '@mantine/notifications'

// Key for storing 401 error info in sessionStorage (same as in api.ts)
const UNAUTHORIZED_ERROR_KEY = 'unauthorized_error'

/**
 * Hook that checks for stored unauthorized error in sessionStorage
 * and displays notification if found. Used to show error after redirect.
 */
export default function useUnauthorizedErrorHandler() {
  useEffect(() => {
    const checkForUnauthorizedError = () => {
      try {
        const storedError = sessionStorage.getItem(UNAUTHORIZED_ERROR_KEY)

        if (storedError) {
          const errorInfo = JSON.parse(storedError)

          // Check if error is not too old (max 5 seconds to avoid showing stale errors)
          const isRecentError = Date.now() - errorInfo.timestamp < 5000

          if (isRecentError && errorInfo.message) {
            // Show notification
            notifications.show({
              color: 'red',
              message: errorInfo.message,
              autoClose: 8000, // Keep it visible for 8 seconds
            })
          }

          // Clean up the stored error
          sessionStorage.removeItem(UNAUTHORIZED_ERROR_KEY)
        }
      } catch (error) {
        // Silently handle JSON parse errors
        console.warn('Failed to parse unauthorized error from sessionStorage:', error)
        sessionStorage.removeItem(UNAUTHORIZED_ERROR_KEY)
      }
    }

    // Small delay to ensure the app is fully loaded before showing notification
    const timeoutId = setTimeout(checkForUnauthorizedError, 100)

    return () => clearTimeout(timeoutId)
  }, [])
}
